import z from "zod";
import { getUserSchema } from "../../user";

export const getAbsenceSchema = z
	.object({
		absenceId: z.string(),
	})
	.merge(getUserSchema);

export type GetAbsenceSchema = z.infer<typeof getAbsenceSchema>;
